import { render, staticRenderFns } from "./BankWithdrawal.vue?vue&type=template&id=f8bfcce4&scoped=true&"
import script from "./BankWithdrawal.vue?vue&type=script&lang=js&"
export * from "./BankWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bfcce4",
  null
  
)

export default component.exports